<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		@click:outside="$emit('close-dialog')"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">テンプレート情報</v-app-bar-title>
				<v-spacer />
				<v-btn v-if="$vuetify.breakpoint.xs" @click="$emit('close-dialog')" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
				<template v-if="!$vuetify.breakpoint.xs && template.status == 'available'">
					<v-btn
						text
						class="mr-2"
						@click="
							$router.push({
								name: 'template_daily_report_new',
								params: { template_id: template.id },
							})
						"
					>
						<v-icon class="mr-2"> mdi-plus </v-icon>
						日報を作成する
					</v-btn>
				</template>
				<template v-if="!$vuetify.breakpoint.xs && editable">
					<TemplateDeleteDialog :openBtnDesign="['text']" :openBtnColor="'white'">
						<template v-slot:text>
							<div class="py-2">
								削除すると元に戻すことはできず、テンプレートを使用した全ての過去の日報が削除されます。
								<br />
								アーカイブするとテンプレートは使用不可能になりますが、日報は削除されません。
							</div>
						</template>
						<template v-slot:button>
							<v-row no-gutters justify="center">
								<v-btn class="ma-1" @click="deleteTemplate" dense dark color="red">
									<v-icon class="mr-2">mdi-delete</v-icon> 削除する
								</v-btn>
								<v-btn class="ma-1" @click="archiveTemplate" dense dark color="grey">
									<v-icon class="mr-2">mdi-archive</v-icon> アーカイブする</v-btn
								>
							</v-row>
						</template>
					</TemplateDeleteDialog>
				</template>
			</v-app-bar>
			<div class="pa-2">
				<v-row
					no-gutters
					class="mt-2"
					justify="end"
					v-if="$vuetify.breakpoint.xs && template.status == 'available'"
				>
					<v-btn
						class="mr-2"
						color="secondary"
						@click="
							$router.push({
								name: 'template_daily_report_new',
								params: { template_id: template.id },
							})
						"
					>
						<v-icon class="mr-2"> mdi-plus </v-icon>
						日報を作成する
					</v-btn>
					<template v-if="authorized">
						<TemplateDeleteDialog v-if="template.status == 'available'" :openBtnColor="'secondary'">
							<template v-slot:text>
								<div class="py-2">
									削除すると元に戻すことはできず、テンプレートを使用した全ての過去の日報が削除されます。
									<br />
									アーカイブするとテンプレートは使用不可能になりますが、日報は削除されません。
								</div>
							</template>
							<template v-slot:button>
								<v-btn class="ma-1" @click="deleteTemplate" dense dark color="red">
									<v-icon class="mr-2">mdi-delete</v-icon>
									削除する
								</v-btn>
								<v-btn class="ma-1" @click="archiveTemplate" dense dark color="grey">
									<v-icon class="mr-2">mdi-archive</v-icon> アーカイブする</v-btn
								>
							</template>
						</TemplateDeleteDialog>
					</template>
				</v-row>

				<h6 class="text-h6 font-weight-bold color-secondary mb-2 mt-4">基本情報</h6>
				<table width="100%">
					<tbody>
						<v-hover v-slot="{ hover }" close-delay="200" open-delay="200">
							<tr class="record-wit-btn">
								<th width="30%">テンプレート名</th>
								<td width="70%">{{ templateName }}</td>
								<span v-show="hover">
									<TemplateNameFormDialog
										v-if="editable"
										:templateData.sync="template"
										@update-template="updateTemplate"
									/>
								</span>
							</tr>
						</v-hover>
						<tr>
							<th width="30%">部門名</th>
							<td width="70%">{{ template.department.name }}</td>
						</tr>
					</tbody>
				</table>

				<h6 class="text-h6 font-weight-bold color-secondary mb-2 mt-4">デフォルト項目</h6>
				<table width="100%" class="show-dialog-table">
					<thead>
						<tr>
							<th width="30%">項目名</th>
							<td width="70%">型</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th width="30%">件名（必須）</th>
							<td width="70%">テキスト（1行）</td>
						</tr>
						<tr>
							<th width="30%">日付（必須）</th>
							<td width="70%">日付</td>
						</tr>
						<tr>
							<th width="30%">開始時間（必須）</th>
							<td width="70%">時間</td>
						</tr>
						<tr>
							<th width="30%">終了時間（必須）</th>
							<td width="70%">時間</td>
						</tr>
						<tr>
							<th width="30%">場所</th>
							<td width="70%">テキスト（1行）</td>
						</tr>
						<tr>
							<th width="30%">内容</th>
							<td width="70%">テキスト（複数行）</td>
						</tr>
					</tbody>
				</table>
				<v-row class="mx-0 my-4" justify="space-between">
					<h6 class="text-h6 font-weight-bold color-secondary">追加項目</h6>
					<v-spacer />
					<MetaKeyFormDialog
						v-if="editable"
						:id="template.id"
						:metaTypes="metaTypes"
						:polymorphicOptions="polymorphicOptions"
						:optionTypes="optionTypes"
						@add-meta-key="addMetaKey($event)"
					/>
				</v-row>
				<table width="100%" v-if="filteredMetaKeys.length" class="show-dialog-table">
					<thead>
						<tr>
							<th width="30%">項目名</th>
							<td width="70%">概要</td>
						</tr>
					</thead>
					<tbody>
						<DailyReportMetaKeyRecord
							v-for="(metaKey, i) in filteredMetaKeys"
							:metaKeyData.sync="filteredMetaKeys[i]"
							:metaTypes="metaTypes"
							:editable="editable"
							:polymorphicOptions="polymorphicOptions"
							:optionTypes="optionTypes"
							:key="metaKey.id"
							@delete-meta-key="deleteMetaKey($event)"
						/>
					</tbody>
				</table>
				<template v-else> なし </template>
			</div>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-row class="ma-0 pa-0" justify="end">
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" text @click="$emit('close-dialog')"> 閉じる </v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import moment from "moment/min/moment.min.js"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"
import TemplateNameFormDialog from "./DailyReportTemplateNameFormDialog.vue"
import DailyReportMetaKeyRecord from "./DailyReportMetaKeyRecord.vue"
import MetaKeyFormDialog from "./DailyReportMetaKeyFormDialog.vue"
export default {
	components: {
		TemplateDeleteDialog,
		TemplateNameFormDialog,
		DailyReportMetaKeyRecord,
		MetaKeyFormDialog,
	},
	props: {
		authorized: {
			type: Boolean,
			required: true,
			default: false,
		},
		templateData: {
			type: Object,
			required: true,
			default: {
				name: {
					type: String,
					default: null,
					required: true,
				},
				daily_report_meta_keys: {
					type: Array,
					default: [],
					required: false,
				},
			},
		},
		metaTypes: {
			type: Array,
			default: [],
			required: true,
		},
		optionTypes: {
			type: Array,
			required: true,
		},
		polymorphicOptions: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			dialog: true,
			department_id: this.$route.params.department_id,
		}
	},
	methods: {
		addMetaKey(metaKey) {
			this.template.daily_report_meta_keys.push(metaKey)
		},
		deleteMetaKey(id) {
			const metaKey = this.template.daily_report_meta_keys.find((m) => m.id == id)
			const index = this.template.daily_report_meta_keys.indexOf(metaKey)
			this.template.daily_report_meta_keys.splice(index, 1)
		},
		deleteTemplate() {
			const status = "deleted"
			this.updateTemplateStatus(status)
		},

		archiveTemplate() {
			const status = "archived"
			this.updateTemplateStatus(status)
		},
		updateTemplateStatus(status) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/departments/${this.department_id}/daily_report_templates/${this.template.id}`
			axios
				.patch(url, { status }, { headers })
				.then((res) => {
					var message = null
					if (res.data.template.status == "deleted") {
						message = "テンプレートを削除しました。"
					} else if (res.data.template.status == "archived") {
						message = "テンプレートをアーカイブしました。"
					}
					this.$store.dispatch("setFlash", {
						text: message,
						type: "notice",
					})
					this.dialog = false
					this.$emit("close-dialog")
					this.$emit("reload-templates")
				})
				.catch((err) => errorHandling.errorResponse(err))
		},
		updateTemplate(template) {
			this.$emit("reload-templates")
			this.$emit("update-template", template)
		},
	},
	computed: {
		templateName() {
			if (this.template.status == "available") {
				return this.template.name
			} else if (this.template.status == "archived") {
				return `${this.template.name}（アーカイブ済み）`
			}
		},
		filteredMetaKeys() {
			return this.template.daily_report_meta_keys.filter((m) => m.status == "available")
		},
		editable() {
			return this.authorized && this.template.status == "available"
		},
		template: {
			get() {
				return this.templateData
			},
			set(newValue) {
				return this.$emit("update:template", newValue)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

.app-bar-btn {
	background-color: $common-back-color !important;
	color: $main-color !important;
}
table {
	.border-top {
		border-top: 4px white solid;
	}
	thead {
		th {
			padding: 4px;
			border: 1px solid white;
			background-color: rgb(235, 235, 235);
		}
		td {
			padding: 4px;
			border: 1px solid white;
			background-color: rgb(235, 235, 235);
		}
	}
	tbody {
		th {
			padding: 4px;
			background-color: whitesmoke;
		}
		td {
			padding: 4px;
			border: 1px solid whitesmoke;
		}
	}
	.record-wit-btn {
		position: relative;
	}
}
</style>